import { getManagerFeed } from "./managerObjectMocks/getNotifications";
import AppUtils from "@src/utils/appUtils";
import SignolUtils from "@src/utils/signolUtils";
import {
  aviationFormattedNotifications,
  shippingFormattedNotifications,
} from "./operatorObjectMocks/shared/getNotifications";

export function getInappNotificationsFeed(params) {
  console.log("params in func", params);
  let notificationsFeed = [];
  const isShipping = SignolUtils.getIndustry() === "shipping";
  if (params.role === "CAPTAIN") {
    notificationsFeed = isShipping
      ? [...shippingFormattedNotifications]
      : [...aviationFormattedNotifications];
  }
  if (params.role === "FUEL_MANAGER") {
    notificationsFeed = getManagerFeed(params);
  }
  return AppUtils.simulateResponse(notificationsFeed);
}

export function updateNotificationSeen() {
  return AppUtils.simulateResponse({ result: true });
}
